import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getResources } from "@/lib/api";
import BrandBand from "@/components/BrandBand";

export default function Resources() {
  const [resources, setResources] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    getResources().then(setResources).catch(() => {});
  }, []);

  const filtered = resources.filter((r) => {
    if (filter === "all") return true;
    if (filter === "free") return !r.premium;
    if (filter === "premium") return r.premium;
    return true;
  });

  return (
    <div data-testid="resources-page">
      <section className="section pb-0">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-8">
            <div className="overline">Resource library</div>
            <h1 className="font-serif-editorial tight-track mt-6" style={{ fontSize: "clamp(3rem, 6vw, 5.5rem)", lineHeight: 1 }}>
              Downloads & guides.
            </h1>
            <p className="mt-8 text-lg" style={{ maxWidth: "38rem" }}>
              Curated worksheets, protocols, meal plans, and printable trackers — considered tools for the SIBO journey. Free introductory guides, and premium clinician-reviewed protocols.
            </p>
          </div>
        </div>
      </section>

      <section className="pt-24 pb-8">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <div className="rule mb-10" />
          <div className="flex flex-wrap gap-x-8 gap-y-4">
            {["all", "free", "premium"].map((f) => (
              <button
                key={f}
                onClick={() => setFilter(f)}
                data-testid={`resources-filter-${f}`}
                className="overline editorial-link"
                style={{ opacity: filter === f ? 1 : 0.6, color: "var(--olive)" }}
              >
                {f}
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-16">
            {filtered.map((r) => (
              <Link to={`/resources/${r.slug}`} key={r.slug} className="group" data-testid={`resource-card-${r.slug}`}>
                <div className="aspect-[4/5] overflow-hidden" style={{ backgroundColor: "var(--sand)" }}>
                  <img src={r.image} alt={r.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="mt-6 flex items-start justify-between gap-6">
                  <div>
                    <div className="overline">{r.premium ? `Premium · $${r.price.toFixed(0)}` : "Free · Download"}</div>
                    <div className="font-serif-editorial mt-3" style={{ fontSize: "1.65rem", lineHeight: 1.15 }}>{r.title}</div>
                    <div className="mt-3 text-sm opacity-80">{r.pages} pages</div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <BrandBand />
    </div>
  );
}
